/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderSlateSelectQueryVariables = {||};
export type PGAModelBuilderSlateSelectQueryResponse = {|
  +modelSlates: ?$ReadOnlyArray<?{|
    +id: string,
    +gameType: {|
      +name: string
    |},
    +suffix: ?string,
    +slatecompetitionSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +competition: {|
            +name: ?string
          |},
        |}
      |}>
    |},
  |}>
|};
export type PGAModelBuilderSlateSelectQuery = {|
  variables: PGAModelBuilderSlateSelectQueryVariables,
  response: PGAModelBuilderSlateSelectQueryResponse,
|};
*/


/*
query PGAModelBuilderSlateSelectQuery {
  modelSlates {
    id
    gameType {
      name
      id
    }
    suffix
    slatecompetitionSet {
      edges {
        node {
          id
          competition {
            name
            id
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suffix",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderSlateSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SlateType",
        "kind": "LinkedField",
        "name": "modelSlates",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GameTypeType",
            "kind": "LinkedField",
            "name": "gameType",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionTypeConnection",
            "kind": "LinkedField",
            "name": "slatecompetitionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SlateCompetitionType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompetitionType",
                        "kind": "LinkedField",
                        "name": "competition",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAModelBuilderSlateSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SlateType",
        "kind": "LinkedField",
        "name": "modelSlates",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GameTypeType",
            "kind": "LinkedField",
            "name": "gameType",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionTypeConnection",
            "kind": "LinkedField",
            "name": "slatecompetitionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SlateCompetitionType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompetitionType",
                        "kind": "LinkedField",
                        "name": "competition",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f4fbeea20ccd543c4c23271dea255089",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderSlateSelectQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderSlateSelectQuery {\n  modelSlates {\n    id\n    gameType {\n      name\n      id\n    }\n    suffix\n    slatecompetitionSet {\n      edges {\n        node {\n          id\n          competition {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7b9c5b1a3078935ba6b92b57858c5834';

module.exports = node;
